module.exports = __webpack_public_path__ + "media/posonbanner.72d76ded.mp4";